import styles from 'App.module.scss';
import NotFound from 'components/NotFound';
import { BrandProvider } from 'context/Brand';
import { useCallback, useEffect, useRef } from 'react';
import { reportBrandLoadFailure } from 'utils/brandLoadDiagnostics';
import ThemeWrapper from 'wrapper/ThemeWrapper';

if (process.env.REACT_APP_ENV !== 'prod') {
  console.log(
    `%c Your are in ${process.env.REACT_APP_ENV} env !`,
    'background: #222; color: #bada55',
  );
}

function App() {
  const searchParams = new URLSearchParams(window.location.search);
  const parsedData = window.location.pathname.split('/');
  const brandIdentify =
    parsedData[1] || searchParams.get('liff.state')?.split('/')[1];
  const reportedMissingIdentifier = useRef(false);

  useEffect(() => {
    if (brandIdentify) {
      reportedMissingIdentifier.current = false;
    } else if (!reportedMissingIdentifier.current) {
      reportedMissingIdentifier.current = true;
      reportBrandLoadFailure({
        trigger: 'initial',
        attempts: 0,
        diagnostic: { kind: 'missing_identifier' },
      });
    }
  }, [brandIdentify]);

  const autoHeightFix = useCallback(() => {
    const windowsVH = window.innerHeight / 100;
    document.documentElement.style.setProperty('--vh', `${windowsVH}px`);
    window.addEventListener('resize', () => {
      const wh = window.innerHeight / 100;
      document.documentElement.style.setProperty('--vh', `${wh}px`);
    });
  }, []);

  const setLanguage = async () => {
    const allowLang: string[] = ['zh-TW', 'ja', 'en-US', 'th'];
    const currentLang = localStorage.getItem('lang');
    const deviceLang = navigator.language;

    if (!currentLang) {
      localStorage.setItem(
        'lang',
        allowLang.includes(deviceLang) ? deviceLang : allowLang[0],
      );
    }
  };

  useEffect(() => {
    setLanguage();
    setTimeout(() => {
      autoHeightFix();
    }, 100);
  }, [autoHeightFix]);

  if (brandIdentify === 'healthCheck') {
    return <></>;
  }

  if (!brandIdentify) {
    return <NotFound retry={false} />;
  }
  return (
    <div className={styles.container}>
      <BrandProvider brandIdentify={brandIdentify}>
        <ThemeWrapper />
      </BrandProvider>
    </div>
  );
}

export default App;
